import type { Address, Chain } from 'viem';
import { useBalance } from 'wagmi';

type Props = {
  address?: Address;
  token: Address;
  chainId: Chain['id'];
};

export const useTokenBalance = ({ address, token, chainId }: Props) => {
  return useBalance({
    query: { enabled: !!address, staleTime: 0 },
    address,
    token,
    chainId,
  });
};
